import React from "react";

const EmailIcon = () => {
  return (
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.5 2.40332C15.5 1.57832 14.825 0.90332 14 0.90332H2C1.175 0.90332 0.5 1.57832 0.5 2.40332V11.4033C0.5 12.2283 1.175 12.9033 2 12.9033H14C14.825 12.9033 15.5 12.2283 15.5 11.4033V2.40332ZM14 2.40332L8 6.15332L2 2.40332H14ZM14 11.4033H2V3.90332L8 7.65332L14 3.90332V11.4033Z" fill="currentColor"/>
    </svg>
  );
};

export default EmailIcon;
